"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _CleverLogin = _interopRequireDefault(require("./CleverLogin"));
var _api = require("../api");
var _sendErrorToSentry = require("../../teacherDashboard/teacher/components/teacher_app_container/ErrorBoundary/sendErrorToSentry");
var _constants = require("../../teacherDashboard/utils/constants");
var _classCode = _interopRequireDefault(require("./../assets/class-code.svg"));
var _qrCode = _interopRequireDefault(require("./../assets/qr-code.svg"));
var _SuiTurnstile = require("schoolUiComponents/SuiTurnstile");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LastUsedClass = function LastUsedClass(_ref) {
  var rememberMeKlassDetails = _ref.rememberMeKlassDetails,
    sendInteractedEvent = _ref.sendInteractedEvent;
  var _useSuiTurnstileState = (0, _SuiTurnstile.useSuiTurnstileState)(),
    token = _useSuiTurnstileState.token;
  var LOGIN_TYPE = [{
    label: "Class code",
    path: "#student-klasscode?fromPage=Login method selection screen",
    svgImage: /*#__PURE__*/_react["default"].createElement(_classCode["default"], {
      alt: "Class code"
    })
  }, {
    label: "QR code",
    path: "#student-qrcode?fromPage=Login method selection screen",
    svgImage: /*#__PURE__*/_react["default"].createElement(_qrCode["default"], {
      alt: "QR code"
    })
  }];
  var klassOnclickHandler = function klassOnclickHandler(klass) {
    sendInteractedEvent("Continue using last class");
    trackEventsForGuests("Class Login Attempted", {
      "mp_login_user_type": "student",
      "Login Method": "Saved class"
    }, {
      send_mixpanel: true
    });
    _api.APIS.klassCodeLogin(klass === null || klass === void 0 ? void 0 : klass.klass_code, true, token).then(function (res) {
      window.location.href = "/klass/student_roster?loginMethod=Saved class&fromPage=Saved class screen";
    })["catch"](function (error) {
      var _error$response, _error$response5, _error$response5$data, _error$response6;
      if (token && (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) !== 406) {
        var _error$response2;
        if (error !== null && error !== void 0 && (_error$response2 = error.response) !== null && _error$response2 !== void 0 && _error$response2.data) {
          var _error$response3, _error$response3$data, _error$response4, _error$response4$data;
          showFlashMessage((error === null || error === void 0 ? void 0 : (_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : _error$response3$data.debug_message) || (error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : _error$response4$data.message), 'error');
        } else {
          showFlashMessage(_constants.CommonMessages.commonErrorMessage, 'error');
        }
      }
      if (error !== null && error !== void 0 && (_error$response5 = error.response) !== null && _error$response5 !== void 0 && (_error$response5$data = _error$response5.data) !== null && _error$response5$data !== void 0 && _error$response5$data.reload) {
        window.location.reload();
      }
      if ((error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : _error$response6.status) !== 404) {
        var _error$response7, _error$response7$data, _error$response8, _error$response8$data;
        (0, _sendErrorToSentry.sendErrorToSentry)(new Error("Error in klassOnclickHandler inside LastUsedClass " + ((error === null || error === void 0 ? void 0 : (_error$response7 = error.response) === null || _error$response7 === void 0 ? void 0 : (_error$response7$data = _error$response7.data) === null || _error$response7$data === void 0 ? void 0 : _error$response7$data.message) || (error === null || error === void 0 ? void 0 : (_error$response8 = error.response) === null || _error$response8 === void 0 ? void 0 : (_error$response8$data = _error$response8.data) === null || _error$response8$data === void 0 ? void 0 : _error$response8$data.debug_message) || "")), {
          error: error
        });
      }
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "last-used-class",
    "data-sentry-component": "LastUsedClass",
    "data-sentry-source-file": "LastUsedClass.tsx"
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Continue with last used class"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "classes-list"
  }, rememberMeKlassDetails.map(function (klass) {
    var _klass$klass_name;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "student-card-l1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "student-card-l2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "student-card",
      onClick: function onClick() {
        return klassOnclickHandler(klass);
      }
    }, /*#__PURE__*/_react["default"].createElement("label", null, klass === null || klass === void 0 ? void 0 : (_klass$klass_name = klass.klass_name) === null || _klass$klass_name === void 0 ? void 0 : _klass$klass_name.replace(/\+/g, " "), " "), /*#__PURE__*/_react["default"].createElement("div", {
      className: "arrow-icon"
    }, /*#__PURE__*/_react["default"].createElement("i", {
      className: "iconcust-iconBackBtn"
    })))));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "or-sec"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "or-sec-text"
  }, "OR")), /*#__PURE__*/_react["default"].createElement("h5", null, "Login to another class"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "login-btns"
  }, LOGIN_TYPE === null || LOGIN_TYPE === void 0 ? void 0 : LOGIN_TYPE.map(function (type) {
    return /*#__PURE__*/_react["default"].createElement("a", {
      href: type.path,
      className: "login-btn-type",
      onClick: function onClick() {
        return sendInteractedEvent(type.label);
      }
    }, type.svgImage, type.label);
  }), /*#__PURE__*/_react["default"].createElement(_CleverLogin["default"], {
    "data-sentry-element": "CleverLogin",
    "data-sentry-source-file": "LastUsedClass.tsx"
  })));
};
var _default = LastUsedClass;
exports["default"] = _default;